export const cmps = {
    PRODUCTOS: 'productos',
    VERSION: 'version',
    PRESENTACION: 'presentacion',
    URL: 'url',
    TIENDA:'tienda'
}